export default {"src":"/login-app/[GIT_HASH]/_next/static/media/globe.cd67f3f4.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};